import type { KioskCurrentEntry } from '../types';

/**
 * Clocked-in view derivation.
 *
 * NOTE (integration correction): the earlier design tried to build a multi-
 * employee clocked-in list client-side via reconstructTimeline. That is NOT
 * possible — Dev-A's reconstructTimeline is a SINGLE-employee fold and its
 * PunchEvent/DerivedSession carry no employeeId, and offline the kiosk cannot
 * attribute a punch to a person (PINs are verified server-side only). So the
 * authoritative, named clocked-in list comes wholly from `GET /kiosk/current`
 * (Dev-B) and is refreshed after every successful punch/sync. This module only
 * shapes those server-provided entries for display.
 */

/** Server clocked-in entries, ordered most-recent clock-in first. */
export function sortEntriesByRecent(entries: KioskCurrentEntry[]): KioskCurrentEntry[] {
  return [...entries].sort((a, b) =>
    a.clockInAt < b.clockInAt ? 1 : a.clockInAt > b.clockInAt ? -1 : 0
  );
}
